import React, { createContext, useContext, useEffect, useState } from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { isDevMode, getDevToken, getMockUser } from "./authConfig";
import axios from "axios";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const isAuthenticatedFromAzure = useIsAuthenticated();
  
  const [auth, setAuth] = useState(() => {
    if (isDevMode()) {
      const devToken = getDevToken();
      const mockUser = getMockUser();
      
      localStorage.setItem("token", devToken);
      localStorage.setItem("urlToken", devToken);
      localStorage.setItem("user", JSON.stringify(mockUser));
      
      console.log("🔥 DEV MODE ACTIVE - Auto authenticated!");
      console.log("🔥 Mock User:", mockUser);
      
      return {
        isAuthenticated: true,
        token: devToken,
        user: mockUser
      };
    }
    
    return {
      isAuthenticated: !!localStorage.getItem("token") || isAuthenticatedFromAzure,
      token: localStorage.getItem("token"),
      user: JSON.parse(localStorage.getItem("user") || "null")
    };
  });

  // ✅ TOKEN REFRESH MEKANİZMASI (navigate kaldırıldı)
  useEffect(() => {
    if (isDevMode()) {
      return; // Dev mode'da refresh yapma
    }

    const refreshToken = async () => {
      const token = localStorage.getItem("token");
      const refresh = localStorage.getItem("refreshToken");

      if (!token || !refresh) return;

      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.post(`${apiUrl}/api/Auth/RefreshToken`, {
          accessToken: token,
          refreshToken: refresh
        });

        localStorage.setItem("token", response.data.token);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        localStorage.setItem("urlToken", response.data.token);

        console.log("✅ Token refreshed successfully");

      } catch (error) {
        console.error("❌ Token refresh failed", error);
        
        // ✅ Token refresh başarısız → Logout (navigate yerine sadece state temizle)
        localStorage.clear();
        setAuth({ isAuthenticated: false, token: null, user: null });
        
        // ✅ Sayfa yenilenerek login'e yönlendir
        window.location.href = "/supplier-login";
      }
    };

    // ✅ 50 dakikada bir token yenile (token 60 dakika geçerli)
    const interval = setInterval(refreshToken, 50 * 60 * 1000);

    return () => clearInterval(interval);
  }, []); // ✅ navigate dependency kaldırıldı

  useEffect(() => {
    if (isDevMode()) {
      const devToken = getDevToken();
      const mockUser = getMockUser();
      
      setAuth({ 
        isAuthenticated: true, 
        token: devToken,
        user: mockUser
      });
      return;
    }

    if (isAuthenticatedFromAzure) {
      setAuth({ 
        isAuthenticated: true, 
        token: localStorage.getItem("token"),
        user: JSON.parse(localStorage.getItem("user") || "null")
      });
    }
  }, [isAuthenticatedFromAzure]);

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
